import { __assign, __rest } from "tslib";
import React from 'react';
import EditPcpLink from './EditPcpLink';
import PcpDownloadLink from './PcpDownloadLink';
import PcpButtonWithPopover from './PcpButtonWithPopover';
import FreeDownloadLink from './FreeDownloadLink';
import { DownloadButtonMode } from './utils';
import DownloadButtonWithPopover from './DownloadButtonWithPopover';
import { useSubscriptionTier } from '../../../utils/hooks/useSubscriptionTier';
var FreeAndPcpDownloadButton = function (_a) {
    var deviation = _a.deviation, _b = _a.deviation.extended, _c = _b === void 0 ? {} : _b, pcp = _c.pcp, mode = _a.mode, buttonProps = __rest(_a, ["deviation", "deviation", "mode"]);
    var alreadyPurchasedPcp = pcp && pcp.hasUserPurchased;
    var _d = useSubscriptionTier(deviation), member_subscriptions = _d.member_subscriptions, tier = _d.tier, isUserSubscribed = _d.isUserSubscribed;
    var isSubscribedToTierIfAny = member_subscriptions && !!tier && isUserSubscribed;
    // TODO: this is confusing, straighten out
    // TODO: mode and utils.getDownloadButtonMode don't really add anything here, remove
    if (mode === DownloadButtonMode.FREE) {
        return React.createElement(FreeDownloadLink, __assign({ deviation: deviation }, buttonProps));
    }
    else if (mode === DownloadButtonMode.OWNER_PREMIUM) {
        return React.createElement(EditPcpLink, { deviation: deviation });
    }
    else if (mode === DownloadButtonMode.PREMIUM &&
        (alreadyPurchasedPcp || isSubscribedToTierIfAny)) {
        return React.createElement(PcpDownloadLink, __assign({ deviation: deviation }, buttonProps));
    }
    else if (mode === DownloadButtonMode.FREE_AND_PREMIUM && pcp) {
        return React.createElement(DownloadButtonWithPopover, __assign({ deviation: deviation }, buttonProps));
    }
    // DownloadButtonMode.PREMIUM and not having purchased it
    return React.createElement(PcpButtonWithPopover, __assign({ deviation: deviation }, buttonProps));
};
FreeAndPcpDownloadButton.displayName = 'FreeAndPcpDownloadButton';
export default FreeAndPcpDownloadButton;
//# sourceMappingURL=FreeAndPcpDownloadButton.js.map